"use client";
import { cn } from '../lib/utils/cn';
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import useDimensions from "src/hooks/useDimensions";

export const LazyTimeZoneViz = dynamic(() => import("./TimeZoneViz"), {
  loading: () => <p>loading...</p>,
  ssr: false,
});

type TypeOfChanges = NonNullable<
  React.ComponentProps<typeof LazyTimeZoneViz>
>["prop"];

const Button = ({
  isActive,
  className,
  children,
  changeType,
  onClick,
}: {
  isActive: boolean;
  className: string;
  children: React.ReactNode;
  changeType: TypeOfChanges;
  onClick: (c: TypeOfChanges) => void;
}) => {
  return (
    <button
      type="button"
      className={cn(
        "relative inline-flex items-center px-3 py-2 text-sm font-semibold focus:z-10",
        isActive ? "text-(--tw-prose-body)/60" : "hover:bg-gray-50 hover:dark:bg-slate-800 dark:text-(--tw-prose-body)",
        isActive ? "bg-white dark:bg-slate-800" : "bg-white dark:bg-slate-700",
        className,
      )}
      onClick={() => onClick(changeType)}
    >
      {children}
    </button>
  );
};

export const DynamicTimeZoneViz = () => {
  const [loadViz, setLoadViz] = useState(false);
  const [changeType, setChangeType] = useState<TypeOfChanges>("other_after_70");

  const [ref, { width, height }] = useDimensions({ liveMeasure: false });
  useEffect(() => {
    setLoadViz(true);
  }, []);
  if (!loadViz) return null;
  const isDST = changeType === "dst_after_70"

  return (
    <div className="col-start-1 col-span-full">
      <div ref={ref} className="w-full">
        <fieldset className="space-y-1 pb-2">
          <span className="isolate inline-flex rounded-md shadow-sm border rounded dark:border-black">
            <Button
              isActive={!isDST}
              changeType={changeType}
              className="rounded-l border-r dark:border-r-black"
              onClick={() => setChangeType("other_after_70")}
            >
            Non DST
          </Button>
          <Button
            isActive={isDST}
            changeType={changeType}
            className="rounded-r"
            onClick={() => setChangeType("dst_after_70")}
          >
            DST related
          </Button>
        </span>
      </fieldset>

      <LazyTimeZoneViz prop={changeType} width={width} height={height} />
    </div>
    </div >
  );
};
